import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export const SummaryTableRatingText = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="textSmall">NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};